import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION_READ = gql`
  mutation MyMutation($isViewed: Boolean, $notificationId: Int!) {
    updateNotificationRead(isViewed: $isViewed, notificationId: $notificationId)
  }
`;

export const UPDATE_NOTIFICATION_READ_ALL = gql`
  mutation MyMutation($markAllRead: Boolean) {
    updateNotificationRead(markAllRead: $markAllRead)
  }
`;
